import React, { useState } from "react";
import PropTypes from "prop-types";
import { noop } from "lodash-es";

import { userTypes } from "domain/GamesSearch/types";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PlayersList from "components/PlayersDetailing/PlayersList/Index";
import { exclude, transferPlayer } from "domain/Game/api";
import AddPlayer from "components/PlayersDetailing/AddPlayer";
import { useDispatch } from "react-redux";
import { updateGameData as updateGameDataForList } from "domain/GamesSearch/actions";
import { updateGameData as updateGameDataForPage } from "domain/Game/actions";
import { updateGameData as updateRegularGame } from "domain/RegularGames/actions";
import AnimatedModal from "components/Modal/AnimatedModal";
import Button from "ui/Button";

const PlayersDetailing = ({
    players = [],
    isOrganizer,
    isTrainer,
    gameId,
    needReport,
    onPlayerClick = noop,
    isRegular,
    isInvate = false,
    children,
    invitedGroups = [],
    max_players,
}) => {
    const dispatch = useDispatch();
    const [refundForUser, setRefundForUser] = useState(null);
    const isOrganizerRights = isOrganizer || isTrainer;

    const updateGameData = (id, gameData) => {
        if (!isRegular) {
            dispatch(updateGameDataForList(gameId, gameData));
            dispatch(updateGameDataForPage(id, gameData));
            return;
        }
        dispatch(updateRegularGame(gameId, gameData));
    };

    const onRemove = async (userId, userName) => {
        const response = await exclude(
            gameId,
            userId,
            isRegular ? "regular_games" : "games",
            false
        );

        if (userName) {
            setRefundForUser(userName);
        }

        updateGameData(
            gameId,
            isRegular ? response?.regular_game : response.game
        );
    };

    const transferPlayerToMainList = async (userId) => {
        const response = await transferPlayer(gameId, userId);

        updateGameData(gameId, response.game);
    };

    const mainListPlayers =
        players?.filter((player) => !player?.is_reserve) || [];
    const reservePlayers =
        players?.filter((player) => player?.is_reserve) || [];
    const showMainTab = isRegular
        ? players?.length > 0 || children
        : players?.length > 0;
    const title = isRegular ? "Cостав" : "Основной состав";
    const isFreePlaceInMainList = mainListPlayers.length < max_players;

    return (
        <div className="background-block">
            {showMainTab && (
                <Tabs>
                    <TabList>
                        <Tab>{title}</Tab>
                        {reservePlayers.length > 0 && <Tab>Резерв</Tab>}
                    </TabList>

                    <TabPanel>
                        <div>
                            <PlayersList
                                players={isRegular ? players : mainListPlayers}
                                isOrganizer={isOrganizerRights}
                                onRemove={onRemove}
                                isRegular={isRegular}
                                needReport={needReport}
                                onPlayerClick={onPlayerClick}
                                isInvate={isInvate}
                            />
                            {isRegular && children}
                        </div>
                    </TabPanel>
                    {reservePlayers.length > 0 && (
                        <TabPanel>
                            <div>
                                <PlayersList
                                    players={reservePlayers}
                                    isOrganizer={isOrganizerRights}
                                    onRemove={onRemove}
                                    onPlayerClick={onPlayerClick}
                                    isFreePlaceInMainList={
                                        isFreePlaceInMainList
                                    }
                                    transferPlayerToMainList={
                                        transferPlayerToMainList
                                    }
                                />
                            </div>
                        </TabPanel>
                    )}
                </Tabs>
            )}

            {isOrganizerRights && (
                <AddPlayer
                    gameId={gameId}
                    players={players}
                    isRegular={isRegular}
                    invitedGroups={invitedGroups}
                />
            )}

            {refundForUser && (
                <AnimatedModal
                    visible={true}
                    title={`Игрок ${refundForUser} отписан от игры`}
                    onClose={() => setRefundForUser(null)}
                    closeOnOverlay={true}
                    modificators={[`min-padding`]}
                >
                    {(close) => (
                        <>
                            <p className="text-center c-gs-medium-em mb-32">
                                Оплаченные средства будут возвращены игроку
                            </p>
                            <div className="btn-group-row">
                                <Button
                                    primary
                                    size="medium"
                                    mixes={[`m-x-auto`]}
                                    onClick={close}
                                >
                                    <span className="btn__span">Ок</span>
                                </Button>
                            </div>
                        </>
                    )}
                </AnimatedModal>
            )}
        </div>
    );
};

PlayersDetailing.propTypes = {
    players: PropTypes.arrayOf(userTypes),
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isOrganizer: PropTypes.bool,
    isTrainer: PropTypes.bool,
    updateGameData: PropTypes.func.isRequired,
    needReport: PropTypes.bool,
    onPlayerClick: PropTypes.func,
    isRegular: PropTypes.bool,
    isInvate: PropTypes.bool,
    children: PropTypes.node,
    invitedGroups: PropTypes.array,
    max_players: PropTypes.number,
};

export default PlayersDetailing;
